import React, { PureComponent } from 'react';
import { Link } from "react-router-dom";
import Cookie from "js-cookie";
import IsEmpty from "./helpers/IsEmpty";
import RoutePath from './RoutePath';

class Navbar extends PureComponent {
    constructor(props) {
        super(props);
        this.section = {
            first: 'transaction',
            second: 'update',
        };
        this.state = {
            current_section: this.section.first,
            notifbar_hidden: true,
        };
    }

    openNotifBar = () => {
        this.setState({
            notifbar_hidden: false,
        });
        // this.setNotificationSeen();
    }
    closeNotifBar = () => {
        this.setState({
            notifbar_hidden: true
        });
    }

    render() {
        // const authorization = JSON.parse(Cookie.get('authorizations'));
        return (
            <nav className="navbar navbar-expand-lg navbar-light bgc-F9F9F9 border-bottom" style={{ height: '5rem' }}>
                {this.props.children}
                <ul className="nav ml-auto">
                    <li className="nav-item">
                        {!IsEmpty(Cookie.get('token')) &&
                            <div onMouseEnter={this.openNotifBar} onMouseLeave={this.closeNotifBar} className="mr-1 mr-sm-2 mr-md-3 mr-lg-3 mr-xl-3">
                                <span className={`position-relative color-333333`}>
                                    <i className='far fa-bell fa-lg'></i>
                                    <span
                                        className={`position-absolute rounded-circle d-flex justify-content-center align-items-center text-white ${this.state.total_notification_count !== 0 && 'bgc-EC9700'}`}
                                        style={{ top: -5, right: -5, width: '1rem', height: '1rem', fontSize: '0.5rem' }}
                                    >0</span>
                                </span>
                                <div className="position-absolute rounded bg-white shadow-graph py-3" hidden={this.state.notifbar_hidden} style={{ zIndex: 2000, width: '18rem', right: '1rem', top: '3rem' }}>
                                    <div className="row no-gutters">
                                        <div className="col-6 d-flex justify-content-center">
                                            <a
                                                href="javascript:void(0)"
                                                className={`text-decoration-none font-weight-bold ${this.state.current_section === this.section.first ? 'color-0F74BD' : 'color-C1C8CE'}`}
                                                data-section={this.section.first}
                                                onClick={this.handleChangeSection}
                                            >Transaction</a>
                                            <span
                                                className={`ml-1 rounded-circle d-flex justify-content-center align-items-center text-white ${this.state.transaction_notification_count !== 0 && 'bgc-EC9700'}`}
                                                style={{ width: '1.2rem', height: '1.2rem', fontSize: '0.8rem' }}
                                            >0</span>
                                        </div>
                                        <div className="col-6 d-flex justify-content-center">
                                            <a
                                                href="javascript:void(0)"
                                                className={`text-decoration-none font-weight-bold ${this.state.current_section === this.section.second ? 'color-0F74BD' : 'color-C1C8CE'}`}
                                                data-section={this.section.second}
                                                onClick={this.handleChangeSection}
                                            >Update</a>
                                            <span
                                                className={`ml-1 rounded-circle d-flex justify-content-center align-items-center text-white ${this.state.marketing_notification_count !== 0 && 'bgc-EC9700'}`}
                                                style={{ width: '1.2rem', height: '1.2rem', fontSize: '0.8rem' }}
                                            >0</span>
                                        </div>
                                    </div>
                                    <div className="row no-gutters mt-2">
                                        <div className="col-6" style={{ borderTop: this.state.current_section === this.section.first ? '2px solid #0F74BD' : 0 }}></div>
                                        <div className="col-6" style={{ borderTop: this.state.current_section === this.section.second ? '2px solid #0F74BD' : 0 }}></div>
                                    </div>
                                    <div className="" style={{ borderTop: '1px solid #C1C8CE' }}></div>
                                    <div className="text-left notifications-body-adgmu px-3" style={{ maxHeight: '20rem', overflow: 'auto' }}>
                                        <style jsx="true">{`
                                        .notifications-body-adgmu::-webkit-scrollbar {
                                            width: 4px;
                                        }
                                        .notifications-body-adgmu::-webkit-scrollbar-thumb {
                                            background-color: #0F74BD;
                                            border-radius: 4px;
                                        }
                                        .notifications-item-xkvan:hover {
                                            background-color: #EBF5FF;
                                        }
                                    `}</style>
                                    </div>
                                </div>
                            </div>}
                    </li>
                    {/* <li className="nav-item"> */}
                    {/*{authorization.data.find((value, index, obj) => (*/}
                    {/*    value.code === process.env.REACT_APP_MENU_MESSAGE*/}
                    {/*)).type !== 'none' &&*/}
                    {/* <Link to={RoutePath.MESSAGE} className="text-decoration-none position-relative">
                            <i className="far fa-envelope fa-lg color-333333"></i>
                            <span
                                className={`position-absolute rounded-circle d-flex justify-content-center align-items-center text-white ${0 !== 0 && 'bgc-EC9700'}`}
                                style={{top: -5, right: -5, width: '1rem', height: '1rem', fontSize: '0.5rem'}}
                            >0</span>
                        </Link> */}
                    {/*}*/}
                    {/* </li> */}
                </ul>
            </nav>
        );
    }
}

export default Navbar;